export enum Country {
  UnitedStates = 1,
  Canada = 2,
}

export enum AddressType {
  Other = 1,
  PrimaryContact = 2,
  IMEContact = 3,
  PracticeAddress = 4,
  WorkersCompensation = 5,
  DisabilityPaidFamilyLeave = 6,
  Discrimination = 7,
  DepartmentOfLabor = 8,
  DataAdmin = 9,
}

export enum HealthcareCertificationBoard {
  ABMS = 1,
  AOA = 2,
  NCCAOM = 3,
  Other = 4,
}

export enum HealthcareProviderProfession {
  Physician = 20,
  PhysicianAssistant = 2,
}

export enum RecordSourceType {
  BIS = 1,
  SED = 2,
  HPA = 3,
  AEM = 4,
  HCS = 5,
  IC2 = 6,
}

export enum SystemUserType {
  General = 1,
  Attorney = 2,
  Other = 3,
}

export enum WorkRequestStatus {
  Ready = 1,
  InProgress = 2,
  Hold = 3,
  Future = 4,
  Completed = 5,
  AutoClosed = 6,
}

export enum WorkRequestUnitOfTime {
  Hours = 1,
  CalendarDays = 2,
  BusinessDays = 3,
  Minutes = 4,
  HybridCalendarDays = 5,
}

export enum PriorAuthorizationRequestType {
  Medication = 1,
  DurableMedicalEquipment = 2,
  Confirmation = 3,
  NonMtgBodyPartOver1000 = 4,
  NonMtgBodyPartUnder1000 = 5,
  SpecialServices = 6,
  Variance = 7,
}

export enum PriorAuthorizationResponse {
  Grant = 1,
  GrantInPart = 2,
  Deny = 3,
  NoL3MdoReview = 4,
}

export enum PartialGrantType {
  PhysicalMedicine = 1,
  Injection = 2,
  Radiology = 3,
  Surgery = 4,
  MentalHealth = 5,
}

export enum NonMtgServiceType {
  Radiology = 1,
  DiagnosticTest = 2,
  PhysicalMedicineModality = 3,
  Surgery = 4,
  Treatment = 5,
  Other = 6,
}

export enum MtgServiceType {
  Acupuncture = 1,
  Chiropractor = 2,
  OccupationalTherapy = 3,
  PhysicalTherapy = 4,
  Other = 5,
}

export enum NonMtgTherapyType {
  PhysicalTherapy = 1,
  OccupationalTherapy = 2,
  SpeechTherapy = 3,
  VestibularTherapy = 4,
  ChiropracticTherapy = 5,
  Acupuncture = 7,
  Other = 6,
}

export enum MdoSupervisorReviewStatus {
  Approved = 1,
  ConditionallyApproved = 2,
  Rejected = 3,
}

export enum TherapeuticCategory {
  Narcotic = 1,
  AntiAnxietyAgent = 2,
  SkeletalMuscleRelaxant = 3,
  NoneOfTheAbove = 4,
  MedicalMarijuana = 5,
}

export enum PartialGrantFor {
  PhysicalMedicine = 1,
  Injection = 2,
  Radiology = 3,
  Surgery = 4,
  MentalHealth = 5,
}

export enum PriorAuthorizationResponseCategory {
  Administrative = 1,
  ImeScheduling = 2,
  Jurisdiction = 3,
  Medical = 4,
  NoCategory = 5,
}

export enum PriorAuthorizationResponseReason {
  // GRANT (MDO only)
  RequestedTreatmentTestItemApprovedAsWritten = 10,
  BurdenOfProofMet = 11,
  InsurerGrantedAfterDenial = 15,
  // GRANT IN PART
  MedicalDocumentationInsufficientForFullApproval = 50,
  ModelVersionOnWcbFeeScheduleApproved = 51,
  ModelVersionNotOnWcbFeeScheduleApproved = 52,
  Other = 12,
  // MDO Review only
  RequestedTreatmentTestItemPartiallyApproved = 13,
  AuthorizationForPredefinedPeriod = 14,
  AuthorizationForPredefinedPeriodDME = 71,
  // DENY
  ClaimCancelled = 1,
  ClaimBodyPartConditionDisallowed = 2,
  ClaimClosedSection32BoardDecision = 3,
  ClaimWithdrawn = 4,
  ClaimCurrentlyControverted = 5,
  TreatementTestMedicationDmeAlreadyProvided = 6,
  ClaimantDidNotAppearForIme = 7,
  ClaimaintInitiatedImeRescheduleOutsideTimeframe = 8,
  NoJurisdiction = 9,
  ClaimSubjectToFullOffsetPursuantToApprovedTpaSettlement = 53,
  InitiationOfMedication = 32,
  ContinuationOfMedication = 29,
  TrialFailureOfFormularyMedication = 48,
  PainMedication = 36,
  RequestedMedication = 44,
  BrandRequest = 27,
  RedFlags = 43,
  MtgTreatmentNotConsistent = 34,
  MedicalNecessityDocumentationAbsent = 33,
  DiagnosisPlanNotSupportedByClinicalExam = 30,
  DiagnosisPlanNotSupportedByDiagnosticStudies = 31,
  NonInvasiveTreatment = 35,
  PreviousTherapyUseDocumentationAbsent = 40,
  PreviousTherapyResultsDocumentationAbsent = 39,
  PreviousInjectionsSameSiteDocumentationAbsent = 37,
  PreviousInjectionsOutcomeDocumentationAbsent = 38,
  ConservativeTherapyNotAttempted = 28,
  PreviousTreatmentDocumentationAbsent = 41,
  TreatmentGoalsDocumentationAbsent = 46,
  TreatmentGoalsPartialApprovalNotSufficient = 47,
  ProtocolForTreatmentSurgeryNotProvided = 42,
  WcbFeeScheduleItemMeetsPatientRequirement = 49,
  SameOrSimilarParPending = 45,
  // MDO Review only
  SupportingMedicalDoesNotDocumentPositiveResponse = 16,
  NoDocumentationOfClinicalExam = 17,
  SupportingMedicalDoesNotDocumentPositiveCorrelation = 18,
  FailedToCiteSpecificExamples = 19,
  NoTreatmentPlan = 20,
  NoDocumentationForMedicalNecessity = 21,
  DocumenentationMissingExacerbationDetails = 22,
  DocumentationDoesNotSupportTreatmentAboveWhatWasGranted = 23,
  NoRationaleToSupportTreatmentThatIsNotRecommended = 24,
  NoDocumentationForSeriesOfInjections = 25,
  //NoDocumentationForBrandRequest = 27,
}

export enum WorkRequestType {
  ProviderResponseRequested = 1,
  ProviderResponseSubmitted = 2,
}

export enum WorkRequestTypeName {
  ProviderResponseSubmitted = 'Provider Response Submitted',
  JustificationForInsurerUpdate = 'Justification for Insurer/Sender Update',
}

export enum SideOfBodyName {
  NotApplicable = 'Not Applicable',
}

export enum BodyParts {
  Toes = 36,
  GreatToes = 37,
  Fingers = 17,
}

export enum GwpReasons {
  ClaimControverted = 1,
}

export enum MtgSiteName {
  None = 'None',
}
